export const selectInvoiceCreditNote = state => state.invoice.creditNoteData
export const selectInvoiceItemsCreditNote = state => state.invoice.creditNoteData.items
export const selectInvoiceDealers = state => state.invoice.invoiceDealers
export const selectInvoiceIssuedByDealer = state => state.invoice.invoiceIssuedByDealer
export const selectInvoicePrintInstructions = state =>
  state.invoice.invoicePrintInstructions
